import * as React from "react";

// IMPORT BO COMPONENTS
import BOText from "app/components/BOComponents/BOText/BOText";
import BOImage from "app/components/BOComponents/BOImage/BOImage";

import BOSearch from "./BOSearch";
import BODev from "./BODev";

// IMPORT MATERIAL UI
import Menu from "@material-ui/core/Menu";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MenuItem from "@material-ui/core/MenuItem";

// LAYOUT STYLES
import "./BOLayout.css";

// AUTH
import oktaClient from "app/utils/oktaClient";

// IMAGES
const logo = require("app/resources/logo.png");

class BOHeader extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    try {
      this.state = {
        user: oktaClient.getToken().claims.email
      };
    } catch (err) {
      this.state = {
        user: "",
        anchorEl: null
      };
    }

    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    oktaClient.signOut();
    localStorage.removeItem("auth");
    localStorage.removeItem("devAuth");
    window.location.href = "/login.html";
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const Header = () => {
      if (this.props.header.title) {
        return (
          <span className="headerDirectionContainer">
            <h3 className="headerTitle">{this.props.header.title}</h3>
            <h5 className="headerDescription">
              {this.props.header.description}
            </h5>
          </span>
        );
      } else {
        return null;
      }
    };

    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <header id="BOHeader">
        <BOImage src={logo} id="BOLogo" tag={false} link="/" />
        <div className="BOHeaderTitleHeader">
          <BOSearch />
          {Header()}
        </div>

        {process.env.REACT_APP_ENV !== "PRODUCTION" ? <BODev /> : null}

        <BOText text={this.state.user} tag="h5" class="BOHeaderTextUser" />

        <div>
          <IconButton
            aria-label="More"
            aria-owns={open ? "long-menu" : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon
              style={{ color: "white", textShadow: "1px 1px 1px #111" }}
            />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                width: 200
              }
            }}
          >
            <MenuItem onClick={this.signOut}>Sign out</MenuItem>
          </Menu>
        </div>
      </header>
    );
  }
}

export default BOHeader;
